// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#app[data-v-7ba5bd90] {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #2c3e50;\n}\n.w-1920[data-v-7ba5bd90] {\n  max-width: 1920px;\n}\n.h-1080[data-v-7ba5bd90] {\n  height: 1080px;\n}\n.btn-warning[data-v-7ba5bd90] {\n  border: 2px solid #AAA;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
